import { Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editTimesheetDeadline(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>, timesheetDeadline: string | null) =>
    new Promise<Identifiable<Planzone>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<Planzone>>({
          endpoint: `/planzones/${planzone.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            timesheetDeadline,
          },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { editTimesheetDeadline };
